<template lang="pug">
  b-container.white-space(fluid="fluid")
    template(v-if="isLoading === true")
      loading(:height="200")
    template(v-else)
      b-card(header-tag="header")
        b-row
          b-col
            h4(:class="title_class")
              label 通常窓口（カスタマーセンター）
            b-row(:class="info_class")
              b-col(cols="7")
                p.text-nowrap ご契約中のクラウドサービスに関するお問い合わせの電話連絡先となります。
                b-row.align-items-center.justify-content-center.pr-2
                  b-icon.mr-3.mb-2(scale=1.7, icon="telephone-fill", variant="primary")
                  h2.text-primary 0120-365-800
                  b-button.ml-3.mb-2.oral-guidance.btn-outline-info(v-b-modal.modal-oral-guidance)
                    span
                      b-icon.mr-2(scale=1.2, icon="volume-up")
                    | 音声ガイダンスに関する案内 ＋
                b-row
                  b-col(:class="info_section_title_class") 受付時間：
                b-row(cols='1', :class="info_element_class")
                  b-col 当社営業日（平日）：９:００ ～ １７:３０
                  b-col （土日祝日及び当社休業日を除く）
                b-row
                  b-col(:class="info_section_title_class") 対応可能言語：
                b-row(:class="info_element_class")
                  b-col 日本語のみ
                b-row
                  b-col(:class="info_section_title_class") お問い合わせ例：
                b-row(:class="info_element_class")
                  b-col
                    b-row ・ご利用中の製品の機能や操作、設定方法についてのお問い合わせ
                    b-row ・仕様と異なる動作、エラーメッセージの表示などに関すること
                    b-row ・ライセンスの追加、サービスの購入などについてのご相談
                    b-row ・障害もしくは著しいサービスの遅延等に対する調査依頼
                b-row
                  b-col(:class="info_section_title_class") 注意事項：
                b-row(:class="info_element_class")
                  b-col
                    b-row ・お問い合わせ内容により、担当部署から改めてのご回答となる場合がございます。
                    b-row ・技術的または複雑な内容の場合は、メールでのお問い合わせをご利用ください。
              b-col(cols="5")
                b-row.mb-1
                  b-col(:class="info_section_title_class") ■ メールでのお問い合わせ
                b-row.mb-1(:class="info_element_class")
                  b-col.text-center.px-0
                    b-button.btn-font-size.btn-neo-bg-color.btn-outline-light(
                      :href="neoUrl",
                      target="_blank"
                    )
                      b-icon.mr-1(icon="envelope")
                      | desknet's NEO お問い合わせ
                  b-col.text-center.px-0
                    b-button.btn-font-size.chat-bg-color.btn-outline-light(
                      :href="clUrl",
                      target="_blank"
                    )
                      b-icon.mr-1(icon="envelope")
                      | ChatLuck お問い合わせ
                b-row.mt-2
                  b-col(:class="info_section_title_class") 注意事項：
                b-row(:class="info_element_class")
                  b-col
                    b-row ・お問い合わせ内容により、電話でご連絡させていただく場合がございます。
                    b-row ・ご回答までにお時間をいただく場合がございます。
        p(style="height: 30px;")
        b-row#incident
          b-col
            h4(:class="title_class")
              label 時間外障害受付窓口（障害窓口のみ）
            b-row(:class="info_class")
              b-col(cols="7")
                p.text-nowrap ご契約中のクラウドサービスで障害が発生した際の電話連絡先となります。
                b-row.align-items-center.justify-content-center.pr-2
                  b-icon.mr-3.mb-2(scale=1.7, icon="telephone-fill", variant="primary")
                  h2.text-primary 0120-925-114
                  b-button.ml-3.mb-2.oral-guidance.btn-outline-info(v-b-modal.modal-oral-guidance)
                    span
                      b-icon.mr-2(scale=1.2, icon="volume-up")
                    | 音声ガイダンスに関する案内 ＋
                b-row
                  b-col(:class="info_section_title_class") 受付時間：
                b-row(cols='1', :class="info_element_class")
                  b-col 当社営業日（平日）：１７:３０ ～ 翌９:００
                  b-col 土日祝日及び当社休業日：終日
                b-row
                  b-col(:class="info_section_title_class") 対応可能言語：
                b-row(cols='1', :class="info_element_class")
                  b-col 日本語のみ
                b-row
                  b-col(:class="info_section_title_class") お問い合わせ例：
                b-row(cols='1', :class="info_element_class")
                  b-col
                    b-row ・クラウドサービスにアクセスできない（ログイン画面が表示されない）
                    b-row ・サービスへのログイン時にエラーメッセージが表示されてログインできない
                    b-row ・サービスの動作が実用に耐えないほど重い状態が継続している
                b-row
                  b-col(:class="info_section_title_class") 注意事項：
                b-row(cols='1', :class="info_element_class")
                  b-col
                    b-row ・ご契約中のクラウドサービスに障害が発生しサービスがご利用になれない際の
                    | ご連絡先となります。
                    b-row ・機能や操作、サービスの購入などに関するお問い合わせはお受けしておりません。
                    | お手数ですが、メールでのお問い合わせ、もしくは通常窓口の受付時間内にカスタマーセンターまでお問い合わせください。
                    b-row.text-nowrap ・原則として、契約者情報に登録されている担当者様からのご連絡をお願いしております。
              b-col(cols="5")
                b-row
                  b-col(:class="info_section_title_class") ■ 電話をお掛けになる前に
                b-row(:class="info_element_class")
                  b-col
                    b-row お急ぎのことと存じますが、以後の対応を円滑に進めるため、以下の情報をご確認の上お問い合わせください。
                    b-row.mt-4 お客様番号：
                      b-col
                        b-row {{ client_no }}
                    b-row ドメイン名：
                      b-col
                        b-row(v-if="neo_domain_name!== ''") {{formattedDomain(neo_domain_name)}}
                        b-row(v-if="chat_domain_name!== ''") {{formattedDomain(chat_domain_name)}}
                    b-row.mt-4
                      b-col.mr-3.text-nowrap(cols="3")
                        b-row Ⅰ.発生の状況：
                      b-col.pr-0.text-nowrap(cols="7")
                        b-row ①発生中／②発生した（XX時頃）
                      b-col.mr-3.text-nowrap(cols="3")
                        b-row Ⅱ.障害の内容：
                        b-row
                        b-row
                        b-row
                      b-col.pr-0.text-nowrap(cols="7")
                        b-row ①ログイン画面表示（OK／NG）
                        b-row ②ログイン処理（OK／NG）
                        b-row ③利用できるが非常に遅い
                        b-row ④エラーになる（メッセージ内容）
                      b-col.mr-3.text-nowrap(cols="3")
                        b-row Ⅲ.障害の範囲：
                        b-row
                        b-row
                        b-row
                      b-col.pr-0.text-nowrap(cols="7")
                        b-row ①利用者全員
                        b-row ②一部拠点だけ
                        b-row ③自分の周囲だけ
                        b-row ④自分だけ（他は未確認を含む）

        p(style="height: 10px;")
        p.ml-3.text-danger ※ 時間外障害受付窓口は、クラウド版サポートサイトに登録済みのお客様に対して無償でご提供させていただくサポートサービスです。但し今後、サービス内容の変更や終了、有償化など提供方法を変更させていただく場合がございます。

        b-modal#modal-oral-guidance(centered, size="lg", hide-footer)
          //- header
          template(#modal-header="{cancel}")
            .align-items-center.justify-content-center
              b-icon.mr-2(scale=1.2, icon="volume-up")
              | 音声ガイダンスに関するご案内
            button.close(title="閉じる", @click="cancel") ×
          //- body
          template.p-2(#default)
            p.mb-1 本窓口にお電話をいただくと、音声ガイダンスが流れます。
            p.mb-1 お問合せいただきました内容は、適切かつ迅速な回答とサービス品質向上、ならびに円滑な業務遂行を目的に、原則録音させていただきます。
            p.mb-1 また、弊社からお客さまにお電話をおかけした場合にも、同様に原則録音させていただきます。
            p.mb-4 当該記録をこれらの目的以外に使用することはございません。
            p.mb-0 ・コールセンターの品質向上を目的とし、記録情報を基に、対応オペレータについてのアンケートをお願いすることがございます。
            p.mb-0 ・全てのオペレータが対応中の場合、混雑をご案内する音声ガイダンス後、切電させていただく場合がございます。

</template>

<script>
import Api from "@/repositories/api";
import Loading from '@/components/Loading'

const S207CustomerDetailsRepository = Api.get('s207CustomerDetails')

export default {
  name: "ContactInfo",
  components: {
    Loading
  },
  data() {
    return {
      // 顧客番号
      client_no: '',
      // desknet's NEOのドメイン
      neo_domain_name: '',
      // ChatLuckのドメイン
      chat_domain_name: '',
      // 各対応窓口のタイトル
      title_class: "ml-3 font-weight-bold border-top border-bottom py-2 contact-title-bg-color",
      // 各対応窓口の内容
      info_class: "ml-3 mr-1 py-2 px-2 border-top border-bottom border-secondary",
      // 対応窓口内容内のタイトル
      info_section_title_class: "mb-0 mt-2 font-weight-bold",
      // 対応窓口内容のインデント
      info_element_class: "ml-2 mb-0",

      // desknet'S NEO クラウド版お問い合わせURL
      neoUrl: 'https://faq.desknets.com/contact-cloud',
      // ChatLuck クラウド版お問い合わせURL
      clUrl: 'https://faq.chatluck.com/contact-cloud',
      // メールお問い合わせアンカーパラメータ
      anchorParams: {
          'client-no':          '', // 顧客番号
          'company':            '', // 会社名
          'division':           '', // 部署名
          'name':               '', // 担当者名
          'furigana':           '', // 担当者名（フリガナ）
          'tel':                '', // 電話番号
          'email':              '', // メールアドレス
          'email-confirmation': ''  // 確認用メールアドレス
        },

      // ローディングフラグ
      isLoading: false
    }
  },
  created() {
    // 読み込み中
    this.isLoading = true;

    // ローカルストレージから顧客情報を取得する
    this.client_no        = localStorage.getItem('client_no')        // 顧客番号
    this.neo_domain_name  = localStorage.getItem('neo_domain_name')  // desknet's NEO ドメイン名
    this.chat_domain_name = localStorage.getItem('chat_domain_name') // ChatLuck ドメイン名

    S207CustomerDetailsRepository.get()
      .then((response) => {
        // アンカーにパラメータを設定する
        this.anchorParams['client-no']          = response.data.data.customer_info.client_no                    // 顧客番号
        this.anchorParams['company']            = response.data.data.customer_info.firm_name                    // 会社名
        this.anchorParams['division']           = response.data.data.customer_info.department                   // 部署名
        this.anchorParams['name']               = response.data.data.customer_info.person_name                  // 担当者名
        this.anchorParams['furigana']           = this.hiraToKana(response.data.data.customer_info.person_kana) // 担当者名（フリガナ）
        this.anchorParams['tel']                = response.data.data.customer_info.tel                          // 電話番号
        this.anchorParams['email']              = response.data.data.customer_info.e_mail                       // メールアドレス
        this.anchorParams['email-confirmation'] = response.data.data.customer_info.e_mail                       // 確認用メールアドレス

        // URLSearchParamsを使ってアンカー用の文字列を生成
        const params = new URLSearchParams(this.anchorParams);

        // アンカー文字列（#から始まる）
        const anchorString = '#' + params.toString();

        // お客様情報をメールお問い合わせのURLに追加する
        this.neoUrl = this.neoUrl + anchorString
        this.clUrl = this.clUrl + anchorString
      })
      .finally(() => [
        // 読み込み完了
        this.isLoading = false
      ])
  },
  methods: {
    // ドメイン名整形
    formattedDomain (domain) {
      if (domain === null) return

      // 分割文字を保管する変数を初期化
      let splittedDomain = ""

      //  desknet's NEOのドメインの場合
      if (domain.includes(".dn-cloud.com")) {
        splittedDomain = domain.split(".dn-cloud.com");

        return `${splittedDomain[0]} (.dn-cloud.com)`
      }
      // ChatLuckのドメインの場合
      else if (domain.includes(".chatluck.net")) {
        splittedDomain = domain.split(".chatluck.net");

        return `${splittedDomain[0]} (.chatluck.net)`
      }
    }
  },
  watch: {
    /**
     * ローディングが終了した後にアンカーまでスクロールする
     *
     * @param newVal 変更後の値
     */
    isLoading(newVal) {
      if (newVal === false) {
        // DOMの更新が完了した後、実行する
        this.$nextTick(() => {
          // アンカーの位置までスクロールする
          this.scrollToAnchor(this.$route.hash)
        });
      }
    }
  },
}
</script>

<style scoped>
.contact-title-bg-color {
  background-color: #f5f5f5;
}
.oral-guidance{
  border-radius: 30px;
  background-color:white;
}
.btn-font-size {
  font-size: 13.5px;
}
</style>